import { useNavigate } from "react-router-dom";

import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { DeleteButton } from "components/atoms/DangerButton";
import { useModalButtonContext } from "components/organisms/ModalButton";
import { useDeleteUserMutation, UserDetailsFragment } from "pages/Users/Users.graphql-gen";

export default function DeleteUsersModal({ userToDelete }: { userToDelete: UserDetailsFragment }) {
	const { close } = useModalButtonContext();
	const navigate = useNavigate();
	const [deleteUsersMutation] = useDeleteUserMutation({
		refetchQueries: ["PaginateUsers"],
	});

	async function handleDeleteUser() {
		if (userToDelete.userId) {
			await deleteUsersMutation({
				variables: {
					userid: userToDelete.userId,
				},
			});
			close();
			navigate("/users");
		}
	}

	return (
		<Flex
			direction={Direction.column}
			style={{
				width: "400px",
				padding: "16px",
			}}
		>
			<p>Er du sikker på at du vil slette følgende bruker?</p>

			<li>{userToDelete.name}</li>
			<DeleteButton label="Slett bruker" onClick={handleDeleteUser} />
		</Flex>
	);
}
